var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessConv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.826,
    height: 17.826,
    viewBox: "0 0 17.826 17.826",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_181054",
    "data-name": "Path 181054",
    d: "M18.826,6.645V5.159A.63.63,0,0,0,18.76,4.9h0L17.31,1.986A1.783,1.783,0,0,0,15.712,1H4.114a1.783,1.783,0,0,0-1.6.986L1.065,4.892h0A.63.63,0,0,0,1,5.159V6.645A2.68,2.68,0,0,0,2.188,8.867v8.77H1.594a.594.594,0,0,0,0,1.188H18.231a.594.594,0,1,0,0-1.188h-.594V8.867a2.68,2.68,0,0,0,1.188-2.222Zm-1.188,0a1.485,1.485,0,1,1-2.971,0V5.754h2.971Zm-15.449,0V5.754H5.159v.891a1.485,1.485,0,1,1-2.971,0Zm4.159-.891H9.319v.891a1.485,1.485,0,1,1-2.971,0Zm4.159,0h2.971v.891a1.485,1.485,0,1,1-2.971,0ZM3.579,2.515a.594.594,0,0,1,.535-.327h11.6a.594.594,0,0,1,.535.327l1.022,2.05H2.557ZM11.7,17.637H8.13V14.072a.594.594,0,0,1,.594-.594H11.1a.594.594,0,0,1,.594.594Zm4.754,0H12.884V14.072A1.783,1.783,0,0,0,11.1,12.29H8.724a1.783,1.783,0,0,0-1.783,1.783v3.565H3.377V9.319a2.513,2.513,0,0,0,.3.03,2.674,2.674,0,0,0,2.08-1.022,2.674,2.674,0,0,0,4.159,0,2.674,2.674,0,0,0,4.159,0,2.674,2.674,0,0,0,2.08.992,2.513,2.513,0,0,0,.3,0Z",
    transform: "translate(-1 -1)",
    fill: "#bebebe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessConv);
export default __webpack_public_path__ + "static/media/BusinessConv.8da63089c55902027ea011dd202e19cd.svg";
export { ForwardRef as ReactComponent };